/**
 * Copyright Mántum All Rights Reserved.
 */
import PieChart, {
    Connector,
    Export,
    Format,
    Label,
    Legend,
    Series as CommonSeriesSettings,
    Title,
    Tooltip
} from 'devextreme-react/pie-chart';

import type { Palette } from 'devextreme/common/charts';

type PropTypes = {
    advanced?: {
        allowExporting?: boolean;
        allowLegend?: boolean;
        allowTooltip?: boolean;
        entity?: string;
        refresh?: number;
        format?: 'millions';
        revalidate?: boolean;
    };
    dataSource?: unknown[];
    subtitle?: string;
    theme?: Palette;
    title?: string;
    type?: 'donut' | 'doughnut' | 'pie';
};

export default function Doughnut(props: PropTypes) {
    // prettier-ignore
    const {
        advanced = {},
    } = props;

    const {
        allowExporting = false,
        allowLegend = true,
        allowTooltip = false
    } = advanced;

    return (
        <PieChart
            type={props.type}
            palette={props.theme}
            dataSource={props.dataSource}
        >
            <CommonSeriesSettings argumentField={advanced.entity}>
                <Label visible={true} format={props.advanced?.format}>
                    <Connector visible={true} />
                </Label>
            </CommonSeriesSettings>

            <Title text={props.title} subtitle={props.subtitle} />

            <Legend visible={allowLegend} />
            <Export enabled={allowExporting} />
            <Tooltip enabled={allowTooltip}>
                <Format type={props.advanced?.format} />
            </Tooltip>
        </PieChart>
    );
}
